var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.776,
    height: 37.777,
    viewBox: "0 0 37.776 37.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop-02",
    transform: "translate(-3 -2.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M40.49,11.016a1.258,1.258,0,0,0-.973-.461H11.776L10.532,4.023A1.259,1.259,0,0,0,9.3,3H4.259a1.259,1.259,0,1,0,0,2.518H8.253l4.164,21.858a5.647,5.647,0,0,0,5.54,4.585h14.19a5.655,5.655,0,0,0,5.53-4.533L40.751,12.06a1.256,1.256,0,0,0-.261-1.045ZM35.207,26.934a3.13,3.13,0,0,1-3.061,2.51H17.957a3.124,3.124,0,0,1-3.066-2.537L12.256,13.074H37.98Z",
    transform: "translate(0 0)",
    fill: "#361f6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M14.778,27a3.778,3.778,0,1,0,3.778,3.778A3.782,3.782,0,0,0,14.778,27Zm0,5.037a1.259,1.259,0,1,1,1.259-1.259A1.261,1.261,0,0,1,14.778,32.037Z",
    transform: "translate(2.073 6.221)",
    fill: "#361f6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M27.778,27a3.778,3.778,0,1,0,3.778,3.778A3.782,3.782,0,0,0,27.778,27Zm0,5.037a1.259,1.259,0,1,1,1.259-1.259A1.261,1.261,0,0,1,27.778,32.037Z",
    transform: "translate(5.443 6.221)",
    fill: "#361f6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M18.259,22.814a1.26,1.26,0,0,0,1.259-1.259v-6.3a1.259,1.259,0,1,0-2.518,0v6.3A1.26,1.26,0,0,0,18.259,22.814Z",
    transform: "translate(3.629 2.851)",
    fill: "#361f6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M23.259,22.814a1.26,1.26,0,0,0,1.259-1.259v-6.3a1.259,1.259,0,1,0-2.518,0v6.3A1.26,1.26,0,0,0,23.259,22.814Z",
    transform: "translate(4.924 2.851)",
    fill: "#361f6a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.d14eb10f698f142792d14532795a7cb5.svg";
export { ForwardRef as ReactComponent };